// src/CombinedChart.js

import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, PointElement, Title, Tooltip, Legend, BarElement, LinearScale, LineElement } from 'chart.js';
import GetFormattedDateTime from '../utilities/getFormattedDateTime';

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  PointElement,
  BarElement,
  CategoryScale,
  LinearScale,
  LineElement
);

const CombinedChart = (props) => {
  const chartData = props.chartData;
  const labels = chartData.map(data => GetFormattedDateTime(data.RespondedOn));
  const respondedData = chartData.map(data => data.Responded);  
  const notRespondedData = chartData.map(data => data.NotResponded);
  const peopleContactedData = chartData.map(data => data.PeopleContacted);
  const responseRateData = chartData.map(data => data.ResponseRate); 

  // Combine dataset for chart
  const combineDataset = {
    labels: labels,
    datasets: [
      {
        label: 'ResponseRate',
        type: 'line',
        data: responseRateData,
        fill: false,
        borderColor: '#333333',
        backgroundColor: '#333',
        tension: 0.1,
        borderWidth: 2,
        yAxisID: 'y-axis-2',
      },
      {
        type: 'bar',
        label: 'Responded',
        data: respondedData,
        backgroundColor: '#008000',
        borderWidth: 0,
        stack: 'stack1',
      },
      {
        type: 'bar',
        label: 'Not Responded',
        data: notRespondedData,
        backgroundColor: '#ffb62f',
        borderWidth: 0,
        stack: 'stack1',
      },
      {
        type: 'bar',
        label: 'People Contacted',
        data: peopleContactedData,
        backgroundColor: '#f10000',
        borderWidth: 0,
        stack: 'stack1',
      },
    ],
  };

  // Chart options
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: false,
      },
      legend: {
        display: true,
        position: 'bottom',
        align: 'center',
        labels: {
          padding: (0, 15, 0, 10),
          boxWidth: 7,
          boxHeight: 7,
          usePointStyle: true,
        },
        title: {
          display: true,
          padding: -7,
        },
      },
      datalabels: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem) {
            return tooltipItem.dataset.label + ': ' + tooltipItem.raw;
          },
        },
      },
    },
    layout: {
      padding: {
        bottom: 0,
      },
    },
    scales: {
      x: {
        padding: 0,
        grid: {
          display: false,
        },
        title: {
          display: false,
        },
        ticks: {
          beginAtZero: true,
          padding: 0,
          display: true,
        },
        stacked: true,
        beginAtZero: true,
      },
      y: {
        grid: {
          display: false,
        },
        ticks: {
          suggestedMax: 50,
          suggestedMin: 1,
          beginAtZero: true,
          max: 100,
          autoSkip: true,
          lineHeight: 2,
        },
        stacked: true,
        title: {
          display: true,
          text: 'Response Count',
        },
      },
      'y-axis-2': {
        grid: {
          display: false,
        },
        // min: 0,
        // max: 120,
        type: 'linear',
        position: 'right',
        title: {
          display: true,
          text: 'Response Rate',
        },
        beginAtZero: true,
        stacked: false, 
      },
    },
  };

  return <Bar data={combineDataset} options={options} />;
};

export default CombinedChart;
